import { css } from '@emotion/react'

const S = {
  basic: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    > * {
      flex: 0 0 auto;
    }
  `,
}

export default S
